import React from "react";
import "../css/Footer7.css";

const Footer7 = () => {
  return (
    <footer className="footer7">

      {/* TOP STRIP */}
      <div className="f7-top">
        <div className="f7-brand">
          <h2>PULSE</h2>
          <p>Strength • Energy • Discipline</p>
        </div>

        <div className="f7-socials">
          <a href="#">IG</a>
          <a href="#">FB</a>
          <a href="#">YT</a>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="f7-grid">

        <div className="f7-col">
          <h4>Explore</h4>
          <a href="/">Home</a>
          <a href="/about">About</a>
          <a href="/workouts">Workouts</a>
          <a href="/services">Services</a>
        </div>

        <div className="f7-col">
          <h4>Studio</h4>
          <a href="/plans">Pricing</a>
          <a href="/trainers">Trainers</a>
          <a href="/gallery">Gallery</a>
          <a href="/faqs">FAQs</a>
        </div>

        <div className="f7-col">
          <h4>Contact</h4>
          <p>Downtown Fitness District</p>
          <p>+1 800 555 0923</p>
          <p>train@pulsegym.com</p>
        </div>

      </div>

      {/* BOTTOM */}
      <div className="f7-bottom">
        <div className="f7-bottom-inner">
          <span>© 2025 PULSE GYM</span>
          <span>Built for performance</span>
        </div>
      </div>

    </footer>
  );
};

export default Footer7;
